
import { ISelectItem } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import { UserInfo } from "@/models/dossier/user-info";
import { AuthService, DossierService } from "@/services";

export default Vue.extend({
	data(){
		return {
			users: [] as UserInfo[],
		};
	},
	props: {
		value: {
			type: Array as ()=>number[],
			required: true
		},
		label: String,
		removeSelf: Boolean,
		fancy: Boolean,
	},
	computed: {
		items():ISelectItem<number>[]{
			let result:ISelectItem<number>[] = this.users.map((u) => {
				return {
					text: u.Firstname ? (u.Firstname + " " + u.Lastname) : u.Email,
					value: u.ID
				};
			});
			if (this.removeSelf){
				result = result.filter(u=>u.value != AuthService.wfUser.ID);
			}
			return result;
		}
	},
	methods: {
		onInput(value:number[]){
			this.$emit("input", value);
		}
	},
	async created(){
		this.users = await DossierService.getUsers();
	}
});
